import { ReactNode } from "react";
import "./PageHeader.css";

type Props = {
  title: string
  children?: ReactNode
}

const PageHeader = ({title, children}:Props) => {
  return (
    <header className="page-header">
      <h1 className="page-header__title">{title}</h1>
      {children}
    </header>
  );
}

export default PageHeader